angular.module('AccountingBoxApp')
    .controller('ABUploaderCtrl', function($scope, $rootScope, $http, FileUploader, LoopBackAuth) {
        var url = function() {
            var u = API_ENDPOINT + '/attachments/upload';
            if (LoopBackAuth.currentUserData&&LoopBackAuth.currentUserData.isBookkeeper && $rootScope.currentCompany) {
                u = u + '?currentCompanyId=' + $rootScope.currentCompany.id;
            }
            return u;
        };

        $scope.finished = function() {
          $scope.$broadcast('closedUploadingModal');
        };

        var uploader = $scope.uploader = new FileUploader({

            url: url(),
            headers: {
                'Authorization': LoopBackAuth.accessTokenId,
                'source': 'webapp'
            },
        });

        uploader.onBeforeUploadItem = function(item) {
            // console.log('item url before load');
            item.url = url();
        };

        uploader.onAfterAddingAll = function(addedFileItems) {
            uploader.uploadAll();
            // console.info('onAfterAddingAll', addedFileItems);
        };

        uploader.onSuccessItem = function(fileItem, response, status, headers) {
            console.info('onSuccessItem', fileItem, response, status, headers);
            console.log('response: ', response);
            console.log('Success item upload', fileItem);
            var data = {
                file: fileItem,
                attachment: response.attachment
            };
            $scope.$broadcast('uploadAdded', data);
        };

        uploader.onErrorItem = function(item, response, status, headers) {
          console.warn('onErrorItem: item', item);
          console.warn('onErrorItem: response', response);
          console.warn('onErrorItem: status', status);
          console.warn('onErrorItem: headers', headers);
          throw new Error(response);
        }
        uploader.onError = function(response, status, headers) {
          console.warn('Uploading failed:', response);
          throw new Error(response);
        }
    });
